module.exports = __webpack_public_path__ + "static/media/home_card_img.583a037d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_card_img.png
// module id = 1313
// module chunks = 0